import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminInfo } from '../../interface/organizationModel';
import { LEARNING_SETTING } from '../../constant/organization.constant';

export interface FormState {
  instituteName: string;
  email: string;
  phoneCode: string;
  phoneNumber: string;
  web: string;
  businessRegistrationNo: string;
  primaryLogo: string;
  secondaryLogo: string;
  primaryPreview: string | null;
  secondaryPreview: string | null;
  instituteType: string;
  billingCurrency: string;
  physicalAddressLine1: string;
  physicalAddressLine2: string;
  physicalCountry: string;
  physicalCity: string;
  physicalZipCode: string;
  mailingAddressLine1: string;
  mailingAddressLine2: string;
  mailingCountry: string;
  mailingCity: string;
  mailingZipCode: string;
  sameAsPhysical: boolean;
  teacherCount: string;
  studentCount: string;
  learningSetting: LEARNING_SETTING;
  adminName: string;
  timezone: string;
  role: string;
  adminContactNumber: string;
  adminEmail: string;
  name: string;
  requested_id: string;
  admin_info: [AdminInfo, AdminInfo];
}

const initialState: FormState = {
  instituteName: '',
  email: '',
  phoneCode: '+1', // default same as in useState
  phoneNumber: '',
  web: '',
  businessRegistrationNo: '',
  primaryLogo: '',
  secondaryLogo: '',
  primaryPreview: null,
  secondaryPreview: null,
  instituteType: '',
  billingCurrency: '',
  studentCount: '',
  physicalAddressLine1: '',
  physicalAddressLine2: '',
  physicalCountry: '',
  physicalCity: '',
  physicalZipCode: '',
  mailingAddressLine1: '',
  mailingAddressLine2: '',
  mailingCountry: '',
  mailingCity: '',
  mailingZipCode: '',
  sameAsPhysical: false,
  teacherCount: '',
  learningSetting: LEARNING_SETTING.PHYSICAL,
  timezone: '',
  adminName: '',
  role: '',
  adminContactNumber: '',
  adminEmail: '',
  name: '',
  requested_id: '',
  admin_info: [
    {
      name: '',
      title: '',
      email: '',
      contact_number: '',
      secondary_contact_no: '',
      status: '',
    },
    {
      name: '',
      title: '',
      email: '',
      contact_number: '',
      secondary_contact_no: '',
      status: '',
    },
  ],
};

const registrationFormSlice = createSlice({
  name: 'registrationForm',
  initialState,
  reducers: {
    updateFormData(state, action: PayloadAction<Partial<FormState>>) {
      return { ...state, ...action.payload };
    },
    resetFormData() {
      return initialState;
    },
  },
});

export const { updateFormData, resetFormData } = registrationFormSlice.actions;

export default registrationFormSlice.reducer;
